import { GET_CLIENTS_SUCCESS, GET_CLIENTS_FAIL,GET_CLIENT_LOADING} from "./actionTypes";

const INIT_STATE = {
  client: null,
  error: {},
  loading: false
}

const Clients = (state = INIT_STATE, action) => {
  
  switch (action.type) {
    case GET_CLIENTS_SUCCESS:    
      return {
        ...state,
        client: action.payload,
        loading: false,
      }
      
      case GET_CLIENT_LOADING:
      state = {
        ...state,
        loading: action.payload, 
      }
      
    case GET_CLIENTS_FAIL:
      return {
        ...state,
        error: action.payload,
        loading: false,
      }

    default:
      return state
  }

}

export default Clients
